<template>
	<div>
		<vxe-modal v-model="modal_model" :title="modal_title" :width="modal_width" :height="modal_height" @show="modal_onshow" show-footer @hide="modal_onhide"
			destroy-on-close>
			<template #default>
				<vxe-grid ref="knowledgeList" v-if="list_gridOptions" v-bind="list_gridOptions" @toolbar-button-click="list_toolbarButtonClickEvent"></vxe-grid>
				<edit-form :goodscode="goodscode" :knowledgetype="knowledgetype" ref="editForm" :data="currentrow" @success="editSubmit" />
			</template>
			<template #footer>
				<vxe-button status="" content="返回" @click="modal_cancel"></vxe-button>
			</template>
		</vxe-modal>
	</div>
</template>
<style scoped>

</style>
<script>
	import listMixins from '@_system/components/base/mixins/list/list.js'
	import modalMixins from '@_system/components/base/mixins/modal/modal.js'
	import editForm from './edit.vue'
	export default {
		mixins: [listMixins,modalMixins],
		props: {
			data: {
				default: () => {
					return []
				}
			},
			goodscode:{
				default: () => {
					return []
				}
			},
			knowledgetype:{
				default: () => {
					return 'goodscommon'
				}
			}
		},
		data() {
			return {
				currentrow:{},
				modal_model:false,
				modal_title: '知识列表',
				modal_width:1000,
				modal_height:800,
				list_formConfig: [{
						field: 'question',
						title: '问题',
						itemRender: {
							name: '$input'
						}
					}
				],
				list_columns: [
					{
						field: 'question',
						title: '问题',
					},
					{
						field: 'answer',
						title: '答案'
					},
					{
						field: 'attachment',
						title: '附件',
						formatter: 'file'
					},
					{
						field: 'staffid',
						title: '创建人',
						formatter: 'staff'
					},
					{
						field: 'create_time',
						title: '创建时间',
						formatter: 'date'
					},
					{
						title: '操作',
						fixed: "right",
						align: 'center',
						width: 130,
						slots: {
							default: ({row}) => {
								return [
									<el-button type = "text" size = "mini" onClick = {() => {this.edit(row)}}>编辑</el-button>,
									<el-button type = "text" size = "mini" onClick = {() => {this.del(row)}}>删除</el-button>
								]
							}
						}
					}					
				]
				// list_footerField:[
				// 	{field:'needamount',toFixed:2}
				// ]
			}
		},
		watch: {

		},
		computed: {
			device() {
				return window.systemMethods.device()
			}
		},
		created() {

		},
		mounted() {
			
		},
		methods: {
			modal_init() {
				this.modal_title = this.goodscode ? this.goodscode + ' 知识列表' : '知识列表'
			},
			list_beforeCreateGrid(gridOptions){
				gridOptions.toolbarConfig.buttons = [{
					name: '新增',
					status: 'primary',
					code: 'add'
				}]
				gridOptions.pagerConfig = {
					enabled: true,
					autoHidden: false,
					border: true,
					size: 'mini',
					perfect: false,
					currentPage: 1,
					pageSize: 20,
					pageSizes: [10, 20, 50,100],
				}
				// gridOptions.formConfig = false
			},
			list(page,updateForm,other) {
				return new Promise((resolve) => {
					this.$api.goodsknowledge.listknowledge({
						...page,
						...updateForm,
						...other,
						...{goodscode:this.goodscode,knowledgetype:this.knowledgetype}
					}).then((res)=>{
						resolve(res)
					})
				})
			},
			customreload(){
				this.$refs.knowledgeList.commitProxy('query')
			},
			editSubmit(){
				this.customreload()
			},
			add(){
				this.currentrow = {}
				this.$refs.editForm.modal_show()
			},
			edit(row){
				this.currentrow = row
				this.$refs.editForm.modal_show()
			},
			del(row){
				this.$confirm('是否确认删除', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.loading = true
					this.$api.goodsknowledge.deleteknowledge(row.id,{knowledgetype:this.knowledgetype}).then(() => {
						this.loading = false
						this.customreload()
					}, () => {
						this.loading = false
					})
				}).catch(() => {
					this.loading = false
				})
			},
			submit() {
				//this.init()
			},
			reset() {
				//this.init()
			}
		},
		components: {
			editForm,
			
		}
	}
</script>